module.exports.lan = 'en'
